export default __webpack_public_path__ + "./image/0339c9f83508f01b32c77aaef0c58faa.svg";